Object.defineProperties(exports, $__placeholder__0);


/** WEBPACK FOOTER **
 ** ../../../@traceur/generated/TemplateParser/6
 **/